const data = {
  currentIssueCover: '//www.fastcompany.com/magazine/latest-cover.jpg',
  magazineLink: 'https://www.fastcompany.com/magazine/',
  subscribeLink: 'https://magazine.fastcompany.com/loc/FST/sidenav1999',
  cosites: [
    {
      siteTitle: 'FastCoDesign',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488299643/fc/CO.DESIGN_BURGER_LOCKUP.svg',
      siteURL: '//www.fastcodesign.com'
    },
    {
      siteTitle: 'FastCoStudios',
      siteLogo:
        '//a.fastcompany.net/image/upload/v1488300562/fc/video_burger.svg',
      siteURL: '//www.fastcompany.com/videos'
    }
  ],
  social: {
    fastcompany: [
      {
        property: 'facebook',
        url: 'https://www.facebook.com/FastCompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/fb-icon-cccccc-2x_anjwvt.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/fb-icon-circle-fb.svg'
      },
      {
        property: 'twitter',
        url: 'https://twitter.com/fastcompany',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/tw-icon-cccccc-2x_xgkf9v.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/tw-icon-circle-tw.svg'
      },
      {
        property: 'instagram',
        url: 'https://www.instagram.com/fastcompany/',
        image:
          'https://images.fastcompany.net/image/upload/v1540911625/fcweb/insta-icon-cccccc-2x_qsacmj.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/insta-icon-circle-in.svg'
      },
      {
        property: 'linkedin',
        url: 'https://www.linkedin.com/company/fast-company',
        image:
          'https://images.fastcompany.net/image/upload/v1540911626/fcweb/linkedin-icon-cccccc-2x_ceogdj.svg',
        image_menu:
          'https://images.fastcompany.com/image/upload/v1576118408/linkedin-icon-circle-li.svg'
      },
      {
        property: 'youtube',
        url: 'https://www.youtube.com/user/FastCompany'
      }
    ]
  },
  collections: [
    {
      title: 'collections',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'Tech Forecast',
          url: 'https://www.fastcompany.com/section/tech-forecast',
          deck: 'What’s next for hardware, software, and services'
        },
        {
          title: 'Most Innovative Companies',
          url: 'https://www.fastcompany.com/most-innovative-companies/2020',
          deck: 'Our annual guide to the businesses that matter the most'
        },
        {
          title: 'Most Creative People',
          url: 'https://www.fastcompany.com/most-creative-people/2019',
          deck:
            'Leaders who are shaping the future of business in creative ways'
        },
        {
          title: 'World Changing Ideas',
          url: 'https://www.fastcompany.com/section/world-changing-ideas',
          deck:
            'New workplaces, new food sources, new medicine--even an entirely new economic system'
        },
        {
          title: 'Innovation By Design',
          url: 'https://www.fastcompany.com/innovation-by-design',
          deck: 'Celebrating the best ideas in business'
        }
      ]
    }
  ],
  fastcoworks: [
    {
      title: 'fastco works',
      className: 'main-menu__collections',
      isOpen: false,
      sections: [
        {
          title: 'Adidas Women',
          url: 'https://www.fastcompany.com/fcw/adidas_women',
          deck: ''
        },
        {
          title: 'Alteryx',
          url: 'https://www.fastcompany.com/fcw/alteryx',
          deck: ''
        },
        {
          title: 'McKinsey & Company',
          url: 'https://www.fastcompany.com/fcw/mckinsey__company',
          deck: ''
        },
        {
          title: 'SAP for Midmarket',
          url: 'https://www.fastcompany.com/fcw/sap_for_midmarket',
          deck: ''
        },
        {
          title: 'UserTesting',
          url: 'https://www.fastcompany.com/fcw/usertesting',
          deck: ''
        },
        {
          title: 'Verizon',
          url: 'https://www.fastcompany.com/fcw/verizon',
          deck: ''
        },
        {
          title: 'FastCo Works',
          url: 'https://www.fastcompany.com/user/fastco-works',
          deck:
            "An award-winning team of journalists, designers, and videographers who tell brand stories through Fast Company's distinctive lens"
        }
      ]
    }
  ]
};

export default data;
